import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, NgForm  } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NoteDto } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'receiptModal',
    templateUrl: './receipt-modal.component.html'
})

export class ReceiptModalComponent extends AppComponentBase {

    @ViewChild('receiptModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    id: number = undefined;
    name: string = '';
    note: string = '';
    
    constructor(
        injector: Injector,        
    ) {
        super(injector);        
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }
    
    close(): void {
        this.active = false;
        this.id = undefined;
        this.name = '';
        this.note = '';
        this.modal.hide();
        this.modalSave.emit();
    }
    
    onShown(): void { }   

    public show(id: number, nameReceipt: string, notes?: NoteDto[]): void {
        
        this.id = id;
        this.name = nameReceipt;

        if (notes != undefined)
        {
            notes.forEach(x => {
                this.note += x.description + ' ';
            });
        }

        if (this.isGranted('Pages.Financial.PaymentCharges.ChangeReceiptName')) {
            this.active = true;
            this.modal.show();            
        }
        else {
            this.generateReceipt();
        }
    }    
    
    generateReceipt(): void {
            
        this.loading = true;
       
        this.paymentChargesService
            .getReceipt(this.id, this.name, this.note)
            .finally(() => { this.loading = false; })
            .subscribe(result => {                
                this.fileDownloadService.downloadTempFile(result);
                this.close();
                this.modalSave.emit();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/financial/receivables/modals/receipt/receipt-modal.component.ts